export default "__VITE_ASSET__9c505447__"